import { useContext } from "react"
import OpusContext, { IOpusContext } from "../context"

const useOpus = (): IOpusContext => useContext(OpusContext)

export default useOpus
